var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 3H.75C.34 3 0 2.66 0 2.25s.34-.75.75-.75h16.5c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9.75H.75C.34 9.75 0 9.41 0 9s.34-.75.75-.75h16.5c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 16.5H.75c-.41 0-.75-.34-.75-.75S.34 15 .75 15h16.5c.41 0 .75.34.75.75s-.34.75-.75.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 4.5C4.01 4.5 3 3.49 3 2.25S4.01 0 5.25 0 7.5 1.01 7.5 2.25 6.49 4.5 5.25 4.5Z",
    className: "accent",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.25C13.01 11.25 12 10.24 12 9s1.01-2.25 2.25-2.25S16.5 7.76 16.5 9s-1.01 2.25-2.25 2.25Z",
    className: "accent",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18c-1.24 0-2.25-1.01-2.25-2.25S7.76 13.5 9 13.5s2.25 1.01 2.25 2.25S10.24 18 9 18Z",
    className: "accent",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.739452264665aee2426bda52e9ff5d61.svg";
export { ForwardRef as ReactComponent };